import { KeysOf, ValueOf } from '~types/common';

type FontSizeKeys = KeysOf<typeof fontSize>;

export type FontSize = {
  [key in FontSizeKeys]: ValueOf<typeof fontSize>;
};

const fontSize = {
  H1: '48px',
  H2: '40px',
  H3: '40px',
  H4: '26px',
  H5: '22px',
  T1: '20px',
  T2: '18px',
  B1: '16px',
  B2: '15px',
  B3: '14px',
  C1: '12px',
  C2: '10px',
};

export default fontSize;
